/******************************************************************
 * Load `$localize` - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';

(window as any).global = window;
(window as any).process = {
  env: { DEBUG: undefined },
};